module.exports = __webpack_public_path__ + "static/media/pack.90d0ea0a.png";